define([
  'immutable',
  'moment',
], (Immutable, moment) => {
  function roundNumber(num) {
    if (isNaN(num)) return 0;

    if (num / 1000000 >= 1) {
      return `${(num / 1000000).toFixed(1)}M`;
    } else if (num / 1000 >= 5) {
      return `${(num / 1000).toFixed(0)}K`;
    } else if (num / 1000 >= 1) {
      return `${(num / 1000).toFixed(1)}K`;
    } else {
      return num;
    }
  }

  function getCategoryColor(category) {
    switch(category) {
      case 'contact-form':
        return '#550119';
      case 'inline-form':
        return '#8B2635';
      case 'welcome-mat':
        return '#EE630F';
      case 'smart-bar':
        return '#F38925';
      case 'cart-casino':
        return '#F2D21F';
      case 'click-trigger-popup':
        return '#0EB9E5';
      case 'popup':
        return '#3AD5FF';
      case 'scroll-box':
        return '#0773F8';
      default:
        return '#333333';
    }
  }

  function deslugFormTag(tag) {
    const [label, value] = tag.split(':');

    const newLabel = {
      popup: 'Popup',
      'scroll-box': 'Scroll Box',
      'smart-bar': 'Smart Bar',
      'welcome-mat': 'Welcome Mat',
      'inline-popup': 'Inline Popup',
      'click-trigger-popup': 'Click Trigger',
      game: 'Cart Casino',
    }[label] || label;

    return { form: newLabel, value };
  }

  function isAppInstalled(apps, id) {
    if (!apps || !apps.size) return false;

    let isInstalled = false;
    apps.forEach((app) => {
      if (app.get('app').get('id') === id && app.get('status') === 'installed') {
        isInstalled = true;
      }
    });

    return isInstalled;
  }

  function getFilterGroups(order, filters) {
    return order.map(orderType =>
      filters.get(orderType.type)?.reduce((m, v, k) => {
        if (v.get('enabled')) {
          return m.push(k);
        }
        return m;
      }, Immutable.List()).toJS());
  }

  // Split into units of time
  function splitTime(time) {
    const durationAsSeconds = moment.duration(time, 's');
    const days = Math.floor(durationAsSeconds.asDays());
    const hours = durationAsSeconds.hours();
    const minutes = durationAsSeconds.minutes();

    return [days, hours, minutes];
  }

  function displayTime(time) {
    const [days, hours, minutes] = splitTime(time);

    let formatTime = '';

    // Days
    if (days >= 1) {
      formatTime += `${days} Day`;
      if (days > 1) {
        formatTime += 's';
      }
    }

    // Hours
    if (hours >= 1) {
      if (formatTime.length) {
        formatTime += ', ';
      }
      formatTime += `${hours} Hour`;
      if (hours > 1) {
        formatTime += 's';
      }
    }

    // Minutes
    if (minutes >= 1) {
      if (formatTime.length) {
        formatTime += ', ';
      }
      formatTime += `${minutes} Minutes`;
    }

    // None
    if (!formatTime.length) {
      formatTime = 'None';
    }

    return formatTime;
  }

  // Set the timeUnit lowest measurable timeframe
  function parseTime(delay) {
    const [days, hours, minutes] = splitTime(delay);

    let timeUnit = 'none';
    let time = 0;

    if (days > 0) {
      timeUnit = 'd';
      time = moment.duration(delay, 's').asDays();
    }

    if (hours > 0) {
      timeUnit = 'h';
      time = moment.duration(delay, 's').asHours();
    }

    if (minutes > 0) {
      timeUnit = 'm';
      time = moment.duration(delay, 's').asMinutes();
    }

    return [time, timeUnit];
  }

  return {
    roundNumber,
    getCategoryColor,
    deslugFormTag,
    isAppInstalled,
    getFilterGroups,
    displayTime,
    splitTime,
    parseTime,
  };
});
